import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Animated, Easing, View } from 'react-native';
import { Typography } from '../../../typography';
import { getInputHeight } from '../../InputStyles';
import { tokens } from '../../../../constants';
import { getTestId } from '../../../../utils/commonUtils';
export var AnimatedPlaceholder = props => {
  var _a;
  var ANIMATION_DURATION = 1000;
  var placeholderList = props.placeholderList,
    config = props.config,
    size = props.size,
    variantStyle = props.variantStyle,
    textAreaHeight = props.textAreaHeight,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'AnimatedPlaceholder' : _props$testID;
  var placeholderRef = useRef(new Animated.Value(0)).current;
  var _useState = useState(16),
    height = _useState[0],
    setHeight = _useState[1];
  var _useState2 = useState(0),
    currentPlaceholder = _useState2[0],
    setCurrentPlaceholder = _useState2[1];
  var placeHolderColor = (_a = config.states) === null || _a === void 0 ? void 0 : _a.none.placeholderColor;
  var _getInputHeight = getInputHeight(size, variantStyle, textAreaHeight),
    inputSize = _getInputHeight.inputSize;
  var startAnimation = (height, index) => {
    var value = -(height * index);
    Animated.timing(placeholderRef, {
      toValue: value,
      duration: ANIMATION_DURATION,
      easing: Easing.ease,
      useNativeDriver: true
    }).start(() => {
      setTimeout(() => {
        setCurrentPlaceholder(prevState => {
          return prevState + 1;
        });
      }, ANIMATION_DURATION);
    });
  };
  useEffect(() => {
    if (currentPlaceholder < placeholderList.length) {
      startAnimation(height, currentPlaceholder);
    }
    if (currentPlaceholder >= placeholderList.length && currentPlaceholder !== 0) {
      placeholderRef.setValue(0);
      setCurrentPlaceholder(0);
    }
  }, [currentPlaceholder]);
  return _jsx(View, Object.assign({
    style: {
      height,
      overflow: 'hidden',
      position: 'absolute',
      left: tokens.spacing.SPACING_12,
      top: inputSize / 2 - height / 2,
      zIndex: -1
    }
  }, getTestId(testID), {
    children: _jsx(Animated.View, Object.assign({
      style: {
        transform: [{
          translateY: placeholderRef
        }]
      }
    }, {
      children: placeholderList.map((placeholder, i) => {
        return _jsx(View, {
          children: _jsx(Typography, {
            selectable: false,
            text: placeholder,
            color: placeHolderColor,
            type: "body-single-line-sm",
            onLayout: e => {
              var _a, _b;
              setHeight((_b = (_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.height);
            }
          })
        }, "animated_" + i);
      })
    }))
  }));
};